import { createReducer, on } from '@ngrx/store';
import { ProductsActions } from './products.actions';
import { ProductSliceState } from '../../models/product';


export const initialState: ProductSliceState = {
  items: [],
  status: {
    fetchPaginate: 'idle',
    fetchAll: 'idle',
    create: 'idle',
    update: 'idle',
    delete: 'idle',
    toggleStatus: 'idle',
  },
  error: {
    fetchPaginate: { message: null },
    fetchAll: { message: null },
    create: { message: null },
    update: { message: null },
    delete: { message: null },
    toggleStatus: { message: null },
  },
  pagination: {
    limit: 10,
    previousPage: null,
    currentPage: 1,
    nextPage: null,
    totalItems: 0,
    totalPage: 0,
  },
};

export const productsReducer = createReducer(
  initialState,

  // === FETCH ALL ===
  on(ProductsActions.fetchAll, (state) => ({
    ...state,
    status: { ...state.status, fetchAll: 'pending' },
  })),
  on(ProductsActions.fetchAllSuccess, (state, { items }) => ({
    ...state,
    items,
    status: { ...state.status, fetchAll: 'succeeded' },
  })),
  on(ProductsActions.fetchAllFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, fetchAll: 'failed' },
    error: { ...state.error, fetchAll: error },
  })),

  // === FETCH PAGINATED ===
  on(ProductsActions.fetchPaginated, (state) => ({
    ...state,
    status: { ...state.status, fetchPaginate: 'pending' },
  })),
  on(ProductsActions.fetchPaginatedSuccess, (state, { items, pagination }) => ({
    ...state,
    items,
    pagination,
    status: { ...state.status, fetchPaginate: 'succeeded' },
  })),
  on(ProductsActions.fetchPaginatedFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, fetchPaginate: 'failed' },
    error: { ...state.error, fetchPaginate: error },
  })),

  // === TOGGLE STATUS ===
  on(ProductsActions.toggleStatus, (state) => ({
    ...state,
    status: { ...state.status, toggleStatus: 'pending' },
  })),
  on(ProductsActions.toggleStatusSuccess, (state, { product }) => ({
    ...state,
    items: state.items.map((p) => (p.id === product.id ? product : p)),
    status: { ...state.status, toggleStatus: 'succeeded' },
  })),
  on(ProductsActions.toggleStatusFailure, (state, { error }) => ({
    ...state,
    status: { ...state.status, toggleStatus: 'failed' },
    error: { ...state.error, toggleStatus: error },
  }))
);
